/* global API, Site, I18n */

jQuery(document).ready(($) => {
	$('#toggle-mobile-menu').on('click', function () {
		const expanded = $(this).attr('aria-expanded') === 'true';

		if (expanded) {
			$(this).attr('aria-expanded', false);
			$('.mobile-menu').fadeOut(300);
			$(this).removeClass('open');
			$('body').removeClass('disable-scroll');
		} else {
			$(this).attr('aria-expanded', true);
			$('.mobile-menu').fadeIn(300);
			$(this).addClass('open');
			$('body').addClass('disable-scroll');
		}
	});

	$('button.show-filters').on('click', function () {
		if ($(this).attr('aria-expanded') === 'true') {
			$(this).attr('aria-expanded', false);
			$('body').removeClass('sidebar-open');
			$('.has-sidebar .sidebar').animate({ width: 'toggle' }, 300);
		} else {
			$(this).attr('aria-expanded', true);
			$('.has-sidebar .sidebar').animate({ width: 'toggle' }, 300);
			$('body').addClass('sidebar-open');
		}
	});

	$('.user-menu').on('click', function () {
		$(this).parent().find('.user-menu-content').slideToggle(200);
	});

	$(document).on('click', '.favorite-button.not-vue', function () {
		const postId = $(this).attr('data-post-id');
		const postType = $(this).attr('data-post-type');

		const ajaxArgs = {
			type: 'POST',
			beforeSend(xhr) {
				xhr.setRequestHeader('X-WP-Nonce', API.nonce);
			},
			data: {
				post_id: postId,
				post_type: postType,
			},
		};

		if ($(this).hasClass('favorited')) {
			ajaxArgs.url = `${API.url}/user/remove_favorite`;

			$.ajax(ajaxArgs)
				.fail((jqXHR) => {
					console.error(jqXHR.responseJSON);
				})
				.done(() => {
					$(`.favorite-button.id-${postId}`).each(function () {
						let count = parseInt($(this).children('.favorites-count').html(), 10);

						$(this).removeClass('favorited');

						if (!Number.isNaN(count)) {
							count -= 1;

							if (count <= 1) {
								$(this).children('.favorites-count').html('');
							} else {
								$(this).children('.favorites-count').html(count);
							}
						}
					});
				});
		} else {
			ajaxArgs.url = `${API.url}/user/favorite`;

			$.ajax(ajaxArgs)
				.fail((jqXHR) => {
					console.error(jqXHR.responseJSON);
				})
				.done(() => {
					$(`.favorite-button.id-${postId}`).each(function () {
						let count = parseInt($(this).children('.favorites-count').html(), 10);

						$(this).addClass('favorited');

						if (Number.isNaN(count)) {
							$(this).children('.favorites-count').html('1');
						} else {
							count += 1;

							$(this).children('.favorites-count').html(count);
						}
					});
				});
		}
	});

	$(document).on('click', '.report-post-button', () => {
		$('.report-modal-post').show();
	});

	$(document).on('click', '.report-link-button', () => {
		$('.report-modal-link').show();
	});

	$(document).on('click', '.suggest-ops-button', () => {
		$('.ops-suggestions').show();
	});

	/**
	 * Create a confirm box
	 * @param {string} message Message to show
	 * @param {boolean} closeModal Close the modal after the message
	 */
	function createConfirmBox(message, closeModal = true) {
		const modal = document.querySelectorAll('.modal');
		const body = document.querySelector('body');

		const box = document.createElement('div');
		box.classList.add('confirm-box');

		const content = document.createElement('div');
		content.classList.add('confirm-content');

		const text = document.createElement('p');
		text.classList.add('confirm-text');
		text.innerHTML = message;

		const close = document.createElement('button');
		close.classList.add('confirm-close');
		close.innerHTML = I18n.close;

		close.addEventListener('click', () => {
			box.remove();

			if (closeModal) {
				modal.forEach((element) => {
					const el = element;

					el.style.display = 'none';
				});
			}
		});

		content.appendChild(text);
		content.appendChild(close);
		box.appendChild(content);

		body.appendChild(box);
	}

	$(document).on('click', '#report-post-send', function () {
		const postId = $(this).attr('data-post-id');
		const reason = $('#report-post-reason').val();
		const text = $('#report-post-text').val();
		const name = $('#report-post-name').val();
		const email = $('#report-post-email').val();

		$.ajax({
			type: 'POST',
			url: `${API.url}/report/post`,
			beforeSend(xhr) {
				xhr.setRequestHeader('X-WP-Nonce', API.nonce);
			},
			data: {
				post_id: postId,
				text,
				name,
				email,
				reason,
			},
		})
			.fail((jqXHR) => {
				console.error(jqXHR.responseJSON);
			})
			.done((response) => {
				if (response.status === 200) {
					createConfirmBox(response.message);

					// Reset the fields
					$('#report-post-reason').val('');
					$('#report-post-text').val('');
					$('#report-post-name').val('');
					$('#report-post-email').val('');
				} else {
					createConfirmBox(response.message, false);
				}
			});
	});

	$(document).on('click', '#report-link-send', function () {
		const postId = $(this).attr('data-post-id');
		const reason = $('input[name="report-link-radio"]:checked').val();
		const text = $('#report-link-text').val();

		$.ajax({
			type: 'POST',
			url: `${API.url}/report/link`,
			beforeSend(xhr) {
				xhr.setRequestHeader('X-WP-Nonce', API.nonce);
			},
			data: {
				post_id: postId,
				reason,
				text,
			},
		})
			.fail((jqXHR) => {
				console.error(jqXHR.responseJSON);
			})
			.done((response) => {
				if (response.status === 200) {
					createConfirmBox(response.message);

					// Reset the fields
					$('#report-post-text').val('');
					$('input[name="report-link-radio"]').each(function () {
						$(this).prop('checked', false);
					});
				} else {
					createConfirmBox(response.message, false);
				}
			});
	});

	$(document).on('click', '.modal .close.not-vue', () => {
		$('.modal').hide();
	});

	$(document).on('click', '.modal .report-cancel', () => {
		$('.modal').hide();
	});

	$(document).on('scroll', () => {
		if ($(window).width() > 991) {
			const uHeader = $('.upper-header');

			if (uHeader.length !== 0) {
				const uHeaderOffset = uHeader.offset().top;
				const uHeaderHeight = uHeader.height();

				const headerOffset = uHeaderOffset + uHeaderHeight;

				if ($(window).scrollTop() >= headerOffset) {
					$('.site-header .user-menu.logged-in').fadeIn(100);
					$('.upper-header .user-menu .user-menu-content').hide();
				} else {
					$('.site-header .user-menu.logged-in').fadeOut(100);
					$('.site-header .user-menu .user-menu-content').hide();
				}
			}
		}
	});

	$(document).on('click', '.spot-link', function () {
		const index = $(this).attr('data-index');

		$.ajax({
			type: 'POST',
			url: `${API.url}/spots/increment`,
			beforeSend(xhr) {
				xhr.setRequestHeader('X-WP-Nonce', API.nonce);
			},
			data: {
				index,
			},
		}).fail((jqXHR) => {
			console.error(jqXHR.responseJSON);
		});
	});

	$('.greencomp-block .gc-accordion .gc-control-button').on('click', function () {
		const panel = $(this).attr('aria-controls');

		if ($(this).attr('aria-expanded') === 'true') {
			$(this).attr('aria-expanded', 'false');
			$(`#${panel}`).slideUp(200);
		} else {
			$(this).attr('aria-expanded', 'true');
			$(`#${panel}`).slideDown(200);
		}
	});

	$(document).on('click', '.multiselect .multiselect-select-wrapper, .multiselect .multiselect-select', function () {
		const checkboxes = $(this).parent().parent().find('.multiselect-checkboxes');

		if (checkboxes.hasClass('active')) {
			checkboxes.slideUp(100);
			checkboxes.removeClass('active');
		} else {
			checkboxes.slideDown(100);
			checkboxes.addClass('active');
		}
	});

	$(document).on('click', 'button.create-retki', function () {
		// Create URL params
		const params = new URLSearchParams();

		const collection = $(this).attr('data-collection') || '';

		if (collection) {
			params.append('c', collection);
		}

		// Get destination radio value
		const destination = $('input[name="destination"]:checked').val();

		if (destination) {
			params.append('destination', destination);
		}

		// Get location select value
		const location = $('select[name="location"]').val();

		if (location) {
			params.append('location', location);
		}

		// Get type radio value
		const typeRadio = $('input[name="type"]:checked').val();

		if (typeRadio) {
			if (typeRadio === 'short') {
				params.append('short', 'true');
			}
		}

		// Create URL
		const dataUrl = $(this).attr('data-url');

		// Check if URL is localhost
		let url = dataUrl;

		if (dataUrl.includes('localhost')) {
			url = `http:${url}`;
		}

		url = new URL(url);
		url.search = params.toString();

		// Open the new URL
		window.open(url, '_blank');
	});

	// Audio buttons
	$(document).on('click', '.audio-button', function () {
		const sourceId = $(this).attr('data-source');
		const audioSource = $(`#${sourceId}`);

		if (audioSource.length > 0) {
			// Pause all other audio sources
			$('audio').each(function () {
				$(this).trigger('pause');

				const id = $(this).attr('id');

				if (id !== sourceId) {
					$(`.audio-button[data-source="${id}"]`).removeClass('playing');
					$(`.audio-button[data-source="${id}"]`).attr('aria-pressed', false);
					$(`.audio-button[data-source="${id}"]`).find('span.material-icons-round').html('volume_up');
				}
			});

			audioSource[0].addEventListener('ended', () => {
				$(this).removeClass('playing');
				$(this).find('span.material-icons-round').html('volume_up');
			});

			$(this).toggleClass('playing');
			$(this).attr('aria-pressed', $(this).hasClass('playing'));

			if ($(this).hasClass('playing')) {
				$(audioSource[0]).trigger('play');

				$(this).find('span.material-icons-round').html('pause');
			} else {
				$(audioSource[0]).trigger('pause');

				$(this).find('span.material-icons-round').html('volume_up');
			}
		}
	});

	/**
	 * Snap the tooltip to the screen
	 * @param {HTMLElement} button Button that opens the tooltip
	 */
	function snapTooltip(button) {
		// Make sure that the tooltip is always on the screen
		$('.tooltip').each(function () {
			if ($(this).offset().left < 0) {
				// Try to shift anchor point to the right
				$(this).addClass('anchor-left');

				const rightPos = $(this).offset().left + $(this).width();
				const windowWidth = $(window).width();

				// Check if the tooltip is still off-screen
				if (rightPos > windowWidth) {
					// Offscreen on the right, put anchor point to the top
					$(this).removeClass('anchor-left');

					$(this).addClass('anchor-top');

					// Offset
					const offset = $(this).position().left - $(this).offset().left + 5;

					$(this).css('left', `${offset}px`);

					// Get button position relative to the window
					const buttonLeft = $(button).offset().left - 5;

					$(this).css('--after-left', `${buttonLeft}px`);
					$(this).css('--after-top', '-10px');
				}
			}
		});
	}

	// Bind tooltip snapping to window resize
	$(window).resize(() => {
		$('button.open-tooltip').each(function () {
			if ($(this).attr('aria-expanded') === 'true') {
				const controls = $(this).attr('aria-controls');

				// Remove anchor classes
				$(controls).removeClass('anchor-left');
				$(controls).removeClass('anchor-top');

				// Clear styles first
				$(controls).attr('style', 'display: block;');

				snapTooltip(this);
			}
		});
	});

	// Close tooltips
	/**
	 *
	 */
	function closeTooltips() {
		$('.tooltip').fadeOut(100, () => {
			// Remove anchor classes
			$('.tooltip').removeClass('anchor-left');
			$('.tooltip').removeClass('anchor-top');

			// Remove inline styles
			$('.tooltip').removeAttr('style');

			$('button.open-tooltip').each(function () {
				$(this).attr('aria-expanded', false);
			});
		});
	}

	// Tooltip functionality
	$(document).on('click', 'button.open-tooltip', function () {
		const controls = $(this).attr('aria-controls');

		// Close other tooltips
		$('button.open-tooltip').each(function () {
			// Ignore if this is the clicked button
			if ($(this).attr('aria-controls') === controls) {
				return;
			}

			const active = $(this).attr('aria-expanded');

			if (active === 'true') {
				$(this).attr('aria-expanded', false);

				$(`#${$(this).attr('aria-controls')}`).fadeOut(100);
			}
		});

		const active = $(this).attr('aria-expanded');

		if (active === 'true') {
			closeTooltips();
		} else {
			$(this).attr('aria-expanded', true);

			$(`#${controls}`).fadeIn(100);

			snapTooltip(this);
		}
	});

	/**
	 * Open the sub-menu on the mobile menu
	 */
	$(document).on(
		'click',
		'#mobile-menu li.menu-item-has-children > button, #mobile-menu li.menu-item-has-children > a',
		function (event) {
			event.preventDefault();

			const controls = $(this).attr('aria-controls');
			const expanded = $(this).attr('aria-expanded');
			const submenu = $(`#${controls}`);

			const parentLis = $(this).parents('li');
			const childLis = submenu.children('li');

			if (expanded === 'true') {
				$(this).attr('aria-expanded', 'false');

				$(submenu).hide();
				$(submenu).children('li').hide();
				$(this).parent().removeClass('open');
				$(this).parent().find('.menu-back-button').attr('aria-expanded', 'false');
			} else {
				$(this).attr('aria-expanded', 'true');
				$(this).parent().addClass('open');
				$(this).parent().find('.menu-back-button').attr('aria-expanded', 'true');

				// Hide all other li items expect children of the current submenu and ones that are parents of the current submenu
				$('#mobile-menu li').each(function () {
					if (!parentLis.is(this) && !childLis.is(this)) {
						$(this).hide();
					} else {
						$(this).show();
					}
				});

				$(this).hide();
				$(submenu).show();

				// Set the focus on the first child of the submenu
				$(submenu).children('li').first().find('a, button').focus();
			}
		},
	);

	/**
	 * Close the sub-menu on the mobile menu
	 */
	$(document).on('click', '#mobile-menu .menu-back-button', function () {
		const controls = $(this).attr('aria-controls');
		const selector = `#mobile-menu #${controls}`;

		// // Hide the sub menu
		$(selector).hide();
		$(selector).parent().removeClass('open');

		// Set aria-expanded to false
		$(selector).parent().find('button').attr('aria-expanded', 'false');

		// Show the parent menu
		$(selector).parent().parent().children('li').show();
		$(selector).parent().parent().children('li').children('button').show();

		// Set the focus on the parent menu button
		$(selector).parent().children('a, button').focus();
	});

	$(document).on('click', 'button.close-tooltip', function () {
		closeTooltips();
	});

	// Open the QR-code modal
	$(document).on('click', '#open-qr-modal', function () {
		const controls = $(this).attr('aria-controls');
		const expanded = $(this).attr('aria-expanded');
		const modal = $(`#${controls}`);

		if (expanded === 'false') {
			$(this).attr('aria-expanded', 'true');

			modal.show();
		} else {
			$(this).attr('aria-expanded', 'false');

			modal.hide();
		}
	});

	$(document).on('click', '.modal-qr .close', function () {
		const controls = $(this).attr('aria-controls');

		$(`#${controls}`).hide();

		$('#open-qr-modal').attr('aria-expanded', 'false');
	});

	$(document).on('click', '.modal-qr .print', function () {
		// Print the QR code
		const src = $('.modal-qr img').attr('src');

		const printWindow = window.open('', '_blank');

		printWindow.document.write(
			`<html><body style="display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0;"><img src="${src}" /></body></html>`,
		);

		printWindow.document.close();
		printWindow.focus();

		printWindow.print();
		printWindow.close();
	});

	/**
	 * Open the sub-menu on the primary menu
	 */
	$(document).on(
		'click',
		'#primary-menu li.menu-item-has-children > button, #primary-menu li.menu-item-has-children > a',
		function (event) {
			event.preventDefault();

			const controls = $(this).attr('aria-controls');
			const expanded = $(this).attr('aria-expanded');
			const submenu = $(`#${controls}`);

			// Close all other sub-menus
			$('#primary-menu li.menu-item-has-children > button').each(function () {
				const otherControls = $(this).attr('aria-controls');

				if (otherControls !== controls) {
					$(this).attr('aria-expanded', 'false');
					$(this).parent().removeClass('open');
					$(`#${otherControls}`).slideUp(100);
				}
			});

			if (expanded === 'true') {
				$(this).attr('aria-expanded', 'false');
				$(this).parent().removeClass('open');

				$(submenu).slideUp(100);
			} else {
				$(this).attr('aria-expanded', 'true');
				$(this).parent().addClass('open');

				$(submenu).slideDown(100);
			}
		},
	);

	/**
	 * Set the header height to CSS variable
	 * @param {ResizeObserverEntry[]} entries Resize observer entries
	 */
	function setHeaderHeightCSSVariable(entries) {
		let totalHeaderHeight = 0;

		for (const entry of entries) {
			const element = entry.target;

			if (element) {
				const height = element.offsetHeight;

				totalHeaderHeight += height;
			}
		}

		document.documentElement.style.setProperty('--header-height', `${totalHeaderHeight}px`);
	}

	// Observe the header element for changes
	const headerObserver = new ResizeObserver((entries) => {
		setHeaderHeightCSSVariable(entries);
	});

	if (headerObserver) {
		const headerElement = document.querySelector('.site-header');
		const upperHeaderElement = document.querySelector('.upper-header');

		if (headerElement) {
			headerObserver.observe(headerElement);
		}


		if (upperHeaderElement) {
			headerObserver.observe(upperHeaderElement);
		}
	}

	$(document).on('click', '.service-classes .toggle-children', function () {
		const controls = $(this).attr('aria-controls');
		const expanded = $(this).attr('aria-expanded') === 'true';

		if (expanded) {
			$(this).attr('aria-expanded', 'false');
			$(`#${controls}`).slideUp(200);
		} else {
			$(this).attr('aria-expanded', 'true');
			$(`#${controls}`).slideDown(200);
		}
	});
});
